
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virkjun/[uid]",
      function () {
        return require("private-next-pages/virkjun/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virkjun/[uid]"])
      });
    }
  